"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCultures = createCultures;
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const messages_1 = require("./messages");
const messages = {
    cultures: {
        id: "dashboard.cultures",
        defaultMessage: "Tenyésztések"
    },
    nasalSwabCulture: {
        id: "dashboard.nasal_swab_culture",
        defaultMessage: "Orrtenyésztés"
    },
    throatSwabCulture: {
        id: "dashboard.throat_swab_culture",
        defaultMessage: "Garattenyésztés"
    },
    urineCulture: {
        id: "dashboard.urine_culture",
        defaultMessage: "Vizelettenyésztés"
    },
    asciticFluidCulture: {
        id: "dashboard.ascitic_fluid_culture",
        defaultMessage: "Ascitestenyésztés"
    },
    stoolCulture: {
        id: "dashboard.stool_culture",
        defaultMessage: "Széklettenyésztés"
    }
};
var CultureResult;
(function (CultureResult) {
    CultureResult["NORMAL"] = "NORMAL";
    CultureResult["ABNORMAL"] = "ABNORMAL";
})(CultureResult || (CultureResult = {}));
const groups = [
    {
        label: messages_1.messages.abnormal,
        variant: "dark",
        predicate: (event) => event !== undefined && event.value === CultureResult.ABNORMAL
    },
    {
        label: messages_1.messages.normal,
        variant: "light",
        predicate: (event) => event !== undefined && event.value === CultureResult.NORMAL
    }
];
const values = [
    {
        label: messages.nasalSwabCulture,
        query: queries_1.queries.nasalSwabCulture
    },
    {
        label: messages.throatSwabCulture,
        query: queries_1.queries.throatSwabCulture
    },
    {
        label: messages.urineCulture,
        query: queries_1.queries.urineCulture
    },
    {
        label: messages.asciticFluidCulture,
        query: queries_1.queries.asciticFluidCulture
    },
    {
        label: messages.stoolCulture,
        query: queries_1.queries.stoolCulture
    }
];
function createCultures(intl, { events }) {
    const list = (0, shared_1.createGroupList)(intl, { events, groups, values });
    const content = (0, shared_1.createSectionContent)([list]);
    return (0, shared_1.createSection)(intl, {
        label: messages.cultures,
        content
    });
}
